import { Routes } from '@angular/router';
import { RouterAuthEnum } from 'projects/shared/src/lib/infrastructure/enums/router-link.enum';
import { BarekaRouterEnum } from '@app-bareka/infrastructure/enums/router-link.enum';
import { RouterCommonPagesEnum } from 'projects/shared/src/lib/infrastructure/enums/common-pages.enum';
import { CanDeactivateGuard } from 'projects/shared/src/lib/core/guards/can-deactivate.guard';
import { CanActivateUser } from 'projects/shared/src/lib/core/guards/url-allowed.guard';
import { ProjectName } from 'projects/shared/src/lib/core/enums/project-name.enum';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./pages/test/test.component').then((m) => m.TestComponent),
    canActivate: [CanActivateUser],
    data: {
      // data for canActivateAdmin
      project: ProjectName.Bareka,
    },
  },
  // TODO: just for testing purpose
  {
    path: `${RouterCommonPagesEnum.ContentPlayerTestPage}/task/:taskId/items/:itemId`,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/content-player-test-page/content-player-test-page.component').then(
        (m) => m.ContentPlayerTestPageComponent
      ),
  },
  {
    path: BarekaRouterEnum.TaskResult,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/task-result/task-result.component').then((m) => m.TaskResultComponent),
  },
  // {
  //   path: RouterCommonPagesEnum.UserActivity,
  //   pathMatch: 'full',
  //   loadComponent: () =>
  //     import('./pages/user-activity/user-activity.component').then((m) => m.UserActivityComponent),
  // },
  {
    path: `${RouterCommonPagesEnum.ExampleSum}/:id`,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/exmaple-test/exmaple-test.component').then((m) => m.ExmapleTestComponent),
    canDeactivate: [CanDeactivateGuard],
  },
  {
    path: RouterCommonPagesEnum.Settings,
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/settings/settings.component').then((m) => m.SettingsComponent),
  },
  {
    path: RouterAuthEnum.Callback,
    redirectTo: '',
  },
  {
    path: RouterAuthEnum.LoggedOut,
    loadComponent: () =>
      import('./pages/auth/loggedout/loggedout.component').then((m) => m.LoggedoutComponent),
  },
  {
    path: RouterAuthEnum.Forbidden,
    loadComponent: () =>
      import('./pages/auth/forbidden/forbidden.component').then((m) => m.ForbiddenComponent),
  },
];
